import React from 'react';
import {t} from '@lingui/core/macro';

import {ICity} from 'entities/location';

import AdminFormModal, {IAdminEntityModalProps} from '../AdminList/AdminFormModal';
import CitiesForm from './CitiesForm';

const CitiesModal: React.FC<IAdminEntityModalProps<ICity>> = (props) => (
    <AdminFormModal {...props} addHeader={t`Добавить город`} editHeader={t`Изменить город`} Form={CitiesForm}/>
);

export default CitiesModal;
